import welfareDes from './welfare-des'
export default welfareDes